export const STOREFRONT_CONTENT_TABS = Object.freeze([
  "Global Store Settings",
  "Home Page",
  "Departments",
  "Catalogue Pages",
  "Products",
  "Navigation",
  "Running Banners",
  "Page Registry",
]);

export const BANNER_SPEEDS = Object.freeze(["slow", "normal", "fast"]);
export const BANNER_MODES = Object.freeze(["global", "override", "off"]);

export function revision(value) {
  const result = Number(value);
  return Number.isInteger(result) && result > 0 ? result : null;
}

export function ordered(items, field = "order") {
  return [...(Array.isArray(items) ? items : [])].sort((left, right) => {
    const order = (Number(left?.[field]) || 0) - (Number(right?.[field]) || 0);
    return order || String(left?.key || left?.id || "").localeCompare(String(right?.key || right?.id || ""));
  });
}

export function catalogueRegistry(pages) {
  return ordered((Array.isArray(pages) ? pages : []).filter((page) => (
    page?.type === "catalogue" && typeof page.departmentKey === "string"
      && typeof page.catalogueKey === "string"
  )), "route");
}

export function catalogueIdentity(page) {
  if (!page || page.type !== "catalogue" || !page.departmentKey || !page.catalogueKey) return null;
  return { departmentKey: page.departmentKey, catalogueKey: page.catalogueKey };
}

export function settingsPayload(form) {
  const currentRevision = revision(form?.revision);
  if (!currentRevision) return null;
  return {
    revision: currentRevision,
    shopDisplayName: String(form.shopDisplayName || "").trim(),
    tagline: String(form.tagline || "").trim(),
    footerStatement: String(form.footerStatement || "").trim(),
    returnToDccLabel: String(form.returnToDccLabel || "").trim(),
    productCardActionLabel: String(form.productCardActionLabel || "").trim(),
    productDetailLabels: {
      description: String(form.productDetailLabels?.description || "").trim(),
      specifications: String(form.productDetailLabels?.specifications || "").trim(),
      displayValue: String(form.productDetailLabels?.displayValue || "").trim(),
    },
    defaultBanner: bannerValues(form.defaultBanner),
    experienceConfig: form.experienceConfig,
  };
}

export function pageValues(page) {
  return {
    revision: revision(page?.revision),
    title: String(page?.title || ""),
    supportingText: String(page?.supportingText || ""),
    imageMediaId: page?.imageMediaId || null,
    published: page?.published === true,
  };
}

export function bannerValues(banner) {
  return {
    enabled: banner?.enabled === true,
    text: String(banner?.text || ""),
    backgroundColor: String(banner?.backgroundColor || "#23133A"),
    textColor: String(banner?.textColor || "#F7F2FF"),
    speed: BANNER_SPEEDS.includes(banner?.speed) ? banner.speed : "normal",
  };
}

export function bannerPayload(page, banner) {
  const currentRevision = revision(page?.revision);
  if (!currentRevision) return null;
  return {
    revision: currentRevision,
    mode: BANNER_MODES.includes(banner?.mode) ? banner.mode : "global",
    enabled: banner?.enabled === true,
    text: String(banner?.text || "").trim(),
    backgroundColor: String(banner?.backgroundColor || "").trim() || null,
    textColor: String(banner?.textColor || "").trim() || null,
    speed: BANNER_SPEEDS.includes(banner?.speed) ? banner.speed : null,
  };
}

export function editDestination(page) {
  if (!page) return "Page Registry";
  if (page.type === "home") return "Home Page";
  if (page.type === "department" || page.type === "hub") return "Departments";
  if (page.type === "catalogue") return "Catalogue Pages";
  if (page.type === "product") return "Products";
  return "Running Banners";
}
